module.exports = __webpack_public_path__ + "img/4.80ba0c15.png";